import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import Honeybadger from '@honeybadger-io/js';

import { revokeRefreshToken } from '../../../../../shared/api';
import { ERROR_GENERAL, SUCCESS_LOGOUT } from '../../../../../shared/constants';
import { ToastContext } from '../../../../../shared/context/Toast';
import { useAuth } from '../../../../../shared/hooks';
import { apiClient, LOGOUT } from '../../../../../workspace/shared/api';
import { LOGIN, SIGNUP } from '../../../../../workspace/shared/constants';
import { HOME } from '../../../constants';

import styles from './HeaderLinks.module.scss';

const HeaderLinks = () => {
  const navigate = useNavigate();

  const { clearSession, user } = useAuth();
  const { showError, showSuccess } = useContext(ToastContext);

  const handleClick = () => {
    apiClient
      .delete(LOGOUT)
      .then(async (response) => {
        if (response.status === 204) {
          await revokeRefreshToken();
          clearSession();
          navigate(HOME);
          showSuccess(SUCCESS_LOGOUT);
        } else {
          showError(response.data.errors.join(' '));
        }
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || ERROR_GENERAL;
        showError(errorMessage);
        Honeybadger.notify(error);
      });
  };

  return (
    <ol className={styles.links}>
      {user === null ? (
        <>
          <li>
            <a href={`${gon.workspace_url}${SIGNUP}`}>Create Website</a>
          </li>

          <li>
            <a href={`${gon.workspace_url}${LOGIN}`}>Log In</a>
          </li>
        </>
      ) : (
        <li>
          <button onClick={handleClick} type="button">
            Log Out
          </button>
        </li>
      )}
    </ol>
  );
};

export default HeaderLinks;
